import { api } from 'restaurantAdmin/api';

export interface FinancesDateRangeParams {
  startDate: string;
  endDate: string;
}

export interface FinancesSummary {
  grossEarnings: number;
  netEarnings: number;
  refunds: number;
  refundCount: number;
}

export interface FinancesEarningsByTableRow {
  tableName: string;
  total: number;
  averageCover: number;
  countSold: number;
}

export type FinancesBucketGranularity = 'day' | 'month';

export interface FinancesEarningsTimeseriesBucket {
  bucketStart: string;
  revenue: number;
  refunds: number;
}

export interface FinancesEarningsTimeseries {
  granularity: FinancesBucketGranularity;
  buckets: FinancesEarningsTimeseriesBucket[];
  previousBuckets?: FinancesEarningsTimeseriesBucket[];
}

export interface FinancesRefundBreakdownBucket {
  bucketStart: string;
  canceled: number;
  other: number;
}

export interface FinancesRefundBreakdown {
  granularity: FinancesBucketGranularity;
  buckets: FinancesRefundBreakdownBucket[];
}

const buildDateRangeQuery = ({ startDate, endDate }: FinancesDateRangeParams) =>
  `startDate=${startDate}&endDate=${endDate}`;

export const getFinancesSummary = (
  restaurantId: string,
  dateRange: FinancesDateRangeParams,
): Promise<FinancesSummary> =>
  api.get(
    `/restaurants/${restaurantId}/finances/summary?${buildDateRangeQuery(dateRange)}`,
  );

export const getFinancesEarningsTimeseries = (
  restaurantId: string,
  dateRange: FinancesDateRangeParams,
  compare = false,
): Promise<FinancesEarningsTimeseries> =>
  api.get(
    `/restaurants/${restaurantId}/finances/earnings-timeseries?${buildDateRangeQuery(dateRange)}${compare ? '&compare=true' : ''}`,
  );

export const getFinancesEarningsByTable = (
  restaurantId: string,
  dateRange: FinancesDateRangeParams,
): Promise<FinancesEarningsByTableRow[]> =>
  api.get(
    `/restaurants/${restaurantId}/finances/earnings-by-table?${buildDateRangeQuery(dateRange)}`,
  );

export const getFinancesRefundBreakdown = (
  restaurantId: string,
  dateRange: FinancesDateRangeParams,
): Promise<FinancesRefundBreakdown> =>
  api.get(
    `/restaurants/${restaurantId}/finances/refund-breakdown?${buildDateRangeQuery(dateRange)}`,
  );
